import fetch from 'auth/FetchInterceptor'

const clienteService = {}

clienteService.all = function () {
  return fetch({
    url: '/sms/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

clienteService.paginated = function ({ page = 0, size = 10, numero = '' } = {}) {
  return fetch({
    url: '/sms',
    method: 'get',
    params: { page, size, numero },
  })
}

export default clienteService